<template>
  <div class="additional-fields-form">
    <div
      v-for="key in fieldKeys"
      :key="key"
      :class="'form-group row align-items-center mb-2 '+key"
    >
      <label class="col-md-4 col-form-label mb-md-0" :for="fieldDomId(key)">
        {{ $t(`attributes.details.${key}s.label`) !== `attributes.details.${key}s.label` ?
        $t(`attributes.details.${key}s.label`) :
        $t(`vehicles.attributes.pricing.${key}.label`) }}
      </label>
      <div class="col-md-8">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ currencySymbol }}</span>
          </div>
          <b-form-input
            :id="fieldDomId(key)"
            type="number"
            step="0.01"
            min="0"
            :value="value[key]"
            @input="onInput(key, $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalFieldsForm',

  props: {
    value: {
      type: Object,
      required: true,
    },
    fieldKeys: {
      type: Array,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
  },

  methods: {
    fieldDomId(key) {
      return `vehicle-additional-${key}`
    },
    onInput(key, raw) {
      this.$emit('input', {
        ...this.value,
        [key]: raw,
      })
    },
  },
}
</script>
